import { Product, ProductFilters } from "../../types";
import Loader from "../loader/Loader";
import Pagination from "../pagination/Pagination";
import ProductCard from "../product/ProductCard";

interface ProductsPanelProps {
    products: Product[];
    productsLoading: boolean;
    productsError: string | null;
    total: number;
    filters: ProductFilters;
    updatePage: (page: number) => void;
}

export default function ProductsPanel({
    products,
    productsLoading,
    productsError,
    total,
    filters,
    updatePage,
}: ProductsPanelProps) {
    return (
        <div className="w-full">
            {productsLoading && <Loader />}
            {productsError && <p>Ошибка: {productsError}</p>}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
                {products?.map((product) => (
                    <ProductCard key={product.id} product={product} />
                ))}
            </div>
            <Pagination
                currentPage={filters.offset / filters.limit + 1}
                totalPages={Math.ceil(total / filters.limit)}
                onPageChange={updatePage}
            />
        </div>
    );
}